import React, { useState, useEffect } from 'react'
import styles from './PopUp.module.scss'
import ReportBug from '../Reporting/ReportBug'
import AudioButton from './AudioButton'
import { Location, LanguageEntry, GameResults } from '../../../../types/types'

interface PopUpProps {
  nextRound: () => void
  winner: LanguageEntry
  yourGuess: Location
  gameResults: GameResults
}

const PopUp: React.FC<PopUpProps> = (props) => {
  const [audioSrc, setAudioSrc] = useState('')
  useEffect(() => {
    const file = localStorage.getItem(props.winner.audioPath)
    setAudioSrc(file || '')
  }, [props.winner.audioPath])

  let totalPoints = 0
  let difficulty = 'easy'
  if (props.winner?.level === 2) {
    difficulty = 'medium'
  } else if (props.winner?.level === 3) {
    difficulty = 'hard'
  }
  if (props.gameResults) {
    totalPoints =
      props.gameResults?.points.correctness +
      props.gameResults?.points.closeness +
      props.gameResults?.points.level
  }

  return (
    <div className={styles.popup}>
      <div className={styles.overlay}></div>

      <div
        className={`${styles.container} ${
          props.gameResults?.correct ? styles.success : styles.failure
        }`}
      >
        <div className={styles.message}>
          <p>
            You guessed: <span>{props.yourGuess?.country}</span>
          </p>
          <p>
            You were {props.gameResults?.correct ? 'correct!' : 'incorrect'}
          </p>
          {!props.gameResults?.correct && (
            <p>
              {`Distance to ${props.winner?.common_country} ${props.gameResults?.distance} km`}
            </p>
          )}
          <p>
            Points earned: <span>{totalPoints}</span>
          </p>
        </div>
        <div className={styles.answer}>
          <div className={styles.title}>
            <h1>The language spoken is {props.winner?.language}</h1>
            <div className={styles.labels}>
              <p className={styles.difficulty}>{difficulty}</p>
              <div className={styles.audio}>
                {audioSrc && <AudioButton audioSrc={audioSrc} />}
              </div>
            </div>
          </div>
          <div className={styles.bugReport}>
            <ReportBug
              text="Report incorrect labeling"
              mode="incorrect_label"
              data={{
                filename: props.winner?.audioPath || '',
                current_language: props.winner?.language || '',
                guessed_country: props.yourGuess?.country || '',
                points_earned: totalPoints,
              }}
              onNextRound={props.nextRound}
            />
          </div>
          <p>
            Countries where this is spoken:{' '}
            {props.winner?.all_countries.join(', ')}
          </p>
          <button onClick={props.nextRound}>Continue</button>
        </div>
      </div>
    </div>
  )
}

export default PopUp
